import React, { useEffect, useMemo, useState } from 'react';
import { Oval } from 'react-loader-spinner';
import api from '../services/api';
import {
  Page,
  Hero,
  HeroInner,
  HeroTag,
  ContentSection,
  IntroCard,
  ServicesGrid,
  ServiceCard,
  ServiceIndex,
  EmptyState
} from './ServicesStyles';

const Services = () => {
  const [page, setPage] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    api.services.getPage()
      .then(setPage)
      .catch(err => setError(err.message))
      .finally(() => setLoading(false));
  }, []);

  const services = useMemo(() => (
    Array.isArray(page?.services)
      ? page.services.filter(item => item?.title || item?.description)
      : []
  ), [page]);

  if (loading) return (
    <div style={{ minHeight: '60vh', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
      <Oval height={48} width={48} color="#2E8B57" secondaryColor="#CDEAD7" />
    </div>
  );

  if (error) return <div style={{ padding: 20 }}>Error: {error}</div>;

  return (
    <Page>
      <Hero>
        <HeroInner>
          <HeroTag>What We Do</HeroTag>
          <h1>{page?.title || 'Our Services'}</h1>
          <p>{page?.intro || 'Explore the core services delivered by the Food Authority Liberia.'}</p>
        </HeroInner>
      </Hero>

      <ContentSection>
        <IntroCard>
          <p>
            {page?.intro || 'Explore the core services delivered by the Food Authority Liberia.'}
          </p>
        </IntroCard>

        {services.length ? (
          <ServicesGrid>
            {services.map((service, index) => (
              <ServiceCard key={`${service.title || 'service'}-${index}`}>
                <ServiceIndex>{String(index + 1).padStart(2, '0')}</ServiceIndex>
                <h2>{service.title || `Service ${index + 1}`}</h2>
                {service.description ? <p>{service.description}</p> : null}
              </ServiceCard>
            ))}
          </ServicesGrid>
        ) : (
          <EmptyState>
            Services information will be published here soon. Please check back later.
          </EmptyState>
        )}
      </ContentSection>
    </Page>
  );
};

export default Services;
